import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../../lib/auth";
import { BRAND_LOGO } from "../../lib/brand";
import { useCart, cartCount } from "../../lib/cart";
import HydroMembershipModal from "./HydroMembershipModal";
import { List, X, SignOut, ShoppingBag, Drop } from "@phosphor-icons/react";

export default function BrandHeader() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [hydroOpen, setHydroOpen] = useState(false);
  useCart();

  const links = [
    { to: "/", label: "Home" },
    { to: "/partners", label: "Partners" },
    { to: "/events", label: "Events" },
    { to: "/shop", label: "Shop" },
  ];

  const dashboardLink = () => {
    if (!user) return null;
    if (user.role === "super_admin") return "/admin";
    if (user.role === "merchant_owner") return "/merchant";
    if (user.role === "cashier") return "/scanner";
    if (user.role === "member") return "/me";
    return null;
  };

  const count = cartCount();

  return (
    <>
      <header className="sticky top-0 z-50 glass" data-testid="brand-header">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-5 sm:px-8 py-3">
          <Link to="/" className="flex items-center gap-3" data-testid="brand-logo-link">
            <img src={BRAND_LOGO} alt="The Social Circle" className="h-11 w-11 rounded-full object-cover ring-1 ring-[#D4AF37]/40" />
            <div className="hidden sm:flex flex-col leading-tight">
              <span className="font-display text-base text-white tracking-wide">THE SOCIAL CIRCLE</span>
              <span className="text-[10px] tracking-luxe text-[#D4AF37] uppercase">by Cornerstone</span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-7">
            {links.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
                className={`text-[12px] tracking-luxe uppercase transition-colors ${loc.pathname === l.to ? "text-[#D4AF37]" : "text-white/70 hover:text-white"}`}>
                {l.label}
              </Link>
            ))}
            <button onClick={() => setHydroOpen(true)} data-testid="nav-hydro"
              className="text-[12px] tracking-luxe uppercase text-white/70 hover:text-[#D4AF37] flex items-center gap-1">
              <Drop size={14} weight="duotone" /> Hydro
            </button>
            {count > 0 && (
              <Link to="/checkout" data-testid="nav-cart"
                className="text-[12px] tracking-luxe uppercase text-white/80 hover:text-white flex items-center gap-1.5">
                <ShoppingBag size={14} weight="duotone" /> Cart <span className="text-[#D4AF37]">({count})</span>
              </Link>
            )}
            {user ? (
              <div className="flex items-center gap-3">
                {dashboardLink() && (
                  <Link to={dashboardLink()} className="tsc-btn-outline" data-testid="nav-dashboard">Dashboard</Link>
                )}
                <button onClick={() => { logout(); nav("/"); }} className="text-white/60 hover:text-white" data-testid="nav-logout"><SignOut size={20} /></button>
              </div>
            ) : (
              <div className="flex items-center gap-3">
                <Link to="/login" data-testid="nav-login" className="text-[12px] tracking-luxe uppercase text-white/70 hover:text-white">Sign in</Link>
                <Link to="/register" data-testid="nav-join" className="tsc-btn-gold">Join the Circle</Link>
              </div>
            )}
          </nav>

          <button onClick={() => setOpen(!open)} className="md:hidden text-white" data-testid="nav-mobile-toggle">
            {open ? <X size={26} /> : <List size={26} />}
          </button>
        </div>

        {open && (
          <div className="md:hidden border-t border-white/10 bg-[#070707]" data-testid="nav-mobile-menu">
            <div className="flex flex-col px-6 py-5 gap-4">
              {links.map((l) => (
                <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
                  className="text-[12px] tracking-luxe uppercase text-white/80" data-testid={`mobile-nav-${l.label.toLowerCase()}`}>
                  {l.label}
                </Link>
              ))}
              <button onClick={() => { setOpen(false); setHydroOpen(true); }} className="text-left text-[12px] tracking-luxe uppercase text-white/80 flex items-center gap-1.5" data-testid="mobile-nav-hydro">
                <Drop size={14} weight="duotone" /> Hydro Membership
              </button>
              {count > 0 && (
                <Link to="/checkout" onClick={() => setOpen(false)} className="text-[12px] tracking-luxe uppercase text-white/80 flex items-center gap-1.5" data-testid="mobile-nav-cart">
                  <ShoppingBag size={14} weight="duotone" /> Cart ({count})
                </Link>
              )}
              {user ? (
                <>
                  {dashboardLink() && (
                    <Link to={dashboardLink()} onClick={() => setOpen(false)} className="tsc-btn-outline text-center" data-testid="mobile-nav-dashboard">Dashboard</Link>
                  )}
                  <button onClick={() => { logout(); setOpen(false); nav("/"); }} className="tsc-btn-outline" data-testid="mobile-nav-logout">Sign out</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setOpen(false)} className="tsc-btn-outline text-center" data-testid="mobile-nav-login">Sign in</Link>
                  <Link to="/register" onClick={() => setOpen(false)} className="tsc-btn-gold text-center" data-testid="mobile-nav-join">Join the Circle</Link>
                </>
              )}
            </div>
          </div>
        )}
      </header>
      <HydroMembershipModal open={hydroOpen} onClose={() => setHydroOpen(false)} />
    </>
  );
}
